import React, { useState } from 'react';
import { X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Papa from 'papaparse';
import * as XLSX from 'xlsx';
import { uploadClaimingProfiles } from '../services/claimingProfiles';

const AdminBrokerUploader = () => {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState([]);
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setErrors([]);
    setSuccess('');
    setLoading(true);

    const ext = file.name.split('.').pop().toLowerCase();

    const processData = async (rows) => {
      const valid = [];
      const err = [];

      rows.forEach((row, index) => {
        const rowNum = index + 2;

        if (
          !row.firstName ||
          !row.lastName ||
          // !row.licenseType ||
          // !row.agencyAffiliation ||
          // !row.email ||
          // !row.mobile ||
          !row.licenseNumber ||
          !row.branchName
          // !row.type
        ) {
          err.push(
            `Row ${rowNum}: Missing required fields (firstName, lastName, licenseNumber, branchName).`
          );
          return;
        }

        // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        // if (!emailRegex.test(row.email)) {
        //   err.push(`Row ${rowNum}: Invalid email format.`);
        //   return;
        // }

        valid.push({
          firstName: row.firstName?.trim(),
          lastName: row.lastName?.trim(),
          licenseType: row.licenseType?.trim(),
          agencyAffiliation: row.agencyAffiliation?.trim(),
          branchName: row.branchName?.trim() || '',
          ratingAverage: parseFloat(row.ratingAverage) || 0,
          ratingCount: parseInt(row.ratingCount) || 0,
          primaryLocation: row.primaryLocation?.trim() || '',
          otherLocations:
            row.otherLocations?.split(',').map((l) => l.trim()) || [],
          overview: row.overview || '',
          services: row.services?.split(',').map((s) => s.trim()) || [],
          licenseNumber: row.licenseNumber?.trim() || '',
          licenseIssued: row.licenseIssued || '',
          licenseExpires: row.licenseExpires || '',
          claimURL: row.claimURL || '',
          email: row.email?.trim(),
          mobile: row.mobile?.trim(),
          type: row.type || '',
          ratings: row.ratings ? JSON.parse(row.ratings) : [],
        });
      });

      setErrors(err);

      if (err.length > 0) {
        setLoading(false);
        return;
      }
      if (valid.length > 0) {
        try {
          const response = await uploadClaimingProfiles(valid);

          if (response.error) {
            setErrors((prev) => [...prev, `❌ ${response.error}`]);
          } else if (response.message) {
            setSuccess(`✅ ${response.message}`);
          } else if (response.data) {
            setSuccess('✅ Records uploaded successfully!');
          } else {
            setErrors((prev) => [
              ...prev,
              '❌ Unexpected response from server.',
            ]);
          }
        } catch (err) {
          setErrors((prev) => [
            ...prev,
            `❌ ${err.message || 'Network error.'}`,
          ]);
        }
      }

      setLoading(false);
    };

    if (ext === 'csv') {
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: (result) => processData(result.data),
      });
    } else if (['xls', 'xlsx'].includes(ext)) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const workbook = XLSX.read(e.target.result, { type: 'binary' });
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(sheet);
        processData(jsonData);
      };
      reader.readAsBinaryString(file);
    } else {
      setErrors(['❌ Unsupported file type. Upload CSV or Excel file only.']);
      setLoading(false);
    }
  };

  return (
    <div className="relative max-w-3xl mx-auto p-6 bg-white shadow rounded-xl mt-10">
      <button
        onClick={() => navigate(-1)}
        aria-label="Close"
        className="
          absolute
          top-3
          right-3
          p-1.5
          rounded-md
          text-gray-500
          hover:text-gray-800
          hover:bg-gray-100
          transition
          focus:outline-none
        "
      >
        <X size={20} />
      </button>
      <h2 className="text-lg sm:text-xl font-semibold mb-4 flex items-center gap-2">
        📤 Upload Broker Records
      </h2>

      <input
        type="file"
        accept=".csv, .xls, .xlsx"
        onChange={handleFileUpload}
        className="mb-4 block w-full border border-gray-300 p-2 rounded-md text-sm file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
      />

      {loading && <p className="text-blue-500">Processing file...</p>}

      {success && <p className="text-green-600 font-medium">{success}</p>}

      {errors.length > 0 && (
        <div className="mt-4 text-sm text-red-600 space-y-1">
          <p className="font-semibold">⚠️ Errors:</p>
          <ul className="list-disc list-inside">
            {errors.map((err, i) => (
              <li key={i}>{err}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default AdminBrokerUploader;
